/* LGND Match My Shoes v2 — smarter color extraction, style heuristics,
   up to 8 outfits / ~20+ items, browser-only. */
(function () {
  const stage = document.querySelector('.lgnd-mms__stage');
  if (!stage) return;

  const drop = document.getElementById('mmsDrop');
  const file = document.getElementById('mmsFile');
  const browseBtn = document.getElementById('mmsBrowseBtn');
  const samplesGrid = document.querySelectorAll('.lgnd-mms__sample');
  const shoeImg = document.getElementById('mmsShoeImg');
  const swatchesEl = document.getElementById('mmsSwatches');
  const outfitsEl = document.getElementById('mmsOutfits');
  const restartBtn = document.getElementById('mmsRestart');
  const restartBtn2 = document.getElementById('mmsRestart2');

  let catalog = [];
  try {
    catalog = JSON.parse(document.getElementById('lgnd-mms-catalog').textContent);
  } catch (e) {
    console.error('mms catalog parse', e);
  }

  /* ----------------- helpers ----------------- */
  function setState(s) { stage.setAttribute('data-state', s); }
  function pickFile() { file.click(); }
  function fileToDataUrl(f) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(f);
    });
  }
  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max === min) { h = s = 0; }
    else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }
    return [h * 360, s * 100, l * 100];
  }

  /* ----------------- color extraction (focused on center of image) ----------------- */
  function extractColors(img, k = 6) {
    const cnv = document.createElement('canvas');
    const size = 140;
    cnv.width = size; cnv.height = size;
    const ctx = cnv.getContext('2d');
    ctx.drawImage(img, 0, 0, size, size);
    const data = ctx.getImageData(0, 0, size, size).data;

    const buckets = new Map();
    for (let y = 0; y < size; y++) {
      for (let x = 0; x < size; x++) {
        const i = (y * size + x) * 4;
        const a = data[i + 3];
        if (a < 200) continue;
        const r = data[i], g = data[i + 1], b = data[i + 2];
        const [, s, l] = rgbToHsl(r, g, b);
        // weight by distance from center (focus on subject)
        const cx = size / 2, cy = size / 2;
        const dist = Math.sqrt((x - cx) ** 2 + (y - cy) ** 2) / (size / 2);
        const centerWeight = Math.max(0.3, 1 - dist * 0.7);
        // skip background-ish pixels at the edges
        if (dist > 0.6 && l > 92 && s < 8) continue;
        if (dist > 0.6 && l < 6) continue;
        const qr = r >> 4 << 4;
        const qg = g >> 4 << 4;
        const qb = b >> 4 << 4;
        const key = `${qr},${qg},${qb}`;
        buckets.set(key, (buckets.get(key) || 0) + centerWeight);
      }
    }

    const sorted = [...buckets.entries()].sort((a, b) => b[1] - a[1]);
    const top = sorted.slice(0, k * 4).map(([key, count]) => {
      const [r, g, b] = key.split(',').map(Number);
      const [h, s, l] = rgbToHsl(r, g, b);
      return { r, g, b, h, s, l, count };
    });

    const merged = [];
    for (const c of top) {
      const near = merged.find(m =>
        Math.abs(m.h - c.h) < 18 && Math.abs(m.s - c.s) < 18 && Math.abs(m.l - c.l) < 18
      );
      if (near) { near.count += c.count; }
      else { merged.push({ ...c }); if (merged.length >= k) break; }
    }
    return merged;
  }

  /* ----------------- color → family + brightness analysis ----------------- */
  function colorFamily(c) {
    const { h, s, l } = c;
    if (l > 88) return 'White';
    if (l < 12) return 'Black';
    if (s < 12) {
      if (l < 35) return 'Black';
      if (l > 75) return 'White';
      return 'Grey';
    }
    if (h < 15 || h >= 345) return 'Red';
    if (h < 40) return 'Orange';
    if (h < 65) return 'Yellow';
    if (h < 100) return 'Olive';
    if (h < 160) return 'Green';
    if (h < 200) return 'Teal';
    if (h < 250) return 'Blue';
    if (h < 290) return 'Purple';
    if (h < 345) return 'Pink';
    return 'Neutral';
  }

  // Build a richer palette per family using color theory
  // (matching, complementary, analogous, neutrals)
  function paletteFor(families) {
    const map = {
      White:  ['White', 'Cream', 'Black', 'Grey', 'Charcoal', 'Blue', 'Red', 'Olive', 'Navy', 'Beige', 'Brown'],
      Black:  ['Black', 'Grey', 'Charcoal', 'White', 'Cream', 'Red', 'Olive', 'Brown', 'Beige'],
      Grey:   ['Grey', 'Black', 'White', 'Blue', 'Cream', 'Olive', 'Charcoal', 'Navy'],
      Charcoal:['Charcoal', 'Black', 'White', 'Grey', 'Cream', 'Olive'],
      Cream:  ['Cream', 'Black', 'Brown', 'Olive', 'Beige', 'Blue', 'Navy', 'Forest'],
      Beige:  ['Beige', 'Black', 'Brown', 'Olive', 'Cream', 'White'],
      Brown:  ['Brown', 'Cream', 'Beige', 'White', 'Black', 'Olive', 'Tan'],
      Olive:  ['Olive', 'Black', 'Cream', 'Beige', 'White', 'Brown', 'Khaki'],
      Khaki:  ['Khaki', 'Black', 'White', 'Cream', 'Brown', 'Olive'],
      Red:    ['Black', 'White', 'Grey', 'Cream', 'Red', 'Navy', 'Charcoal'],
      Orange: ['Black', 'White', 'Cream', 'Olive', 'Brown', 'Navy'],
      Yellow: ['Black', 'White', 'Grey', 'Olive', 'Cream', 'Navy', 'Charcoal'],
      Green:  ['Black', 'Cream', 'Beige', 'White', 'Brown', 'Olive', 'Forest', 'Khaki'],
      Forest: ['Forest', 'Cream', 'Beige', 'White', 'Black', 'Khaki'],
      Teal:   ['White', 'Black', 'Cream', 'Beige', 'Navy', 'Grey'],
      Blue:   ['White', 'Black', 'Grey', 'Cream', 'Olive', 'Blue', 'Navy', 'Tan'],
      Navy:   ['Navy', 'White', 'Cream', 'Grey', 'Beige', 'Khaki', 'Tan'],
      Purple: ['Black', 'White', 'Cream', 'Grey'],
      Pink:   ['Black', 'White', 'Grey', 'Cream', 'Navy'],
      Neutral:['Black', 'White', 'Grey', 'Cream']
    };
    const all = new Set();
    families.forEach(f => (map[f] || ['Black','White','Grey']).forEach(c => all.add(c)));
    return [...all];
  }

  /* ----------------- shoe vibe heuristics from color signals ----------------- */
  function detectVibe(colors) {
    // Returns: { vibe: 'casual'|'streetwear'|'athletic'|'smart', brightness: 'light'|'mid'|'dark' }
    const avgL = colors.reduce((s, c) => s + c.l, 0) / colors.length;
    const avgS = colors.reduce((s, c) => s + c.s, 0) / colors.length;
    const brightness = avgL > 70 ? 'light' : avgL < 30 ? 'dark' : 'mid';
    // saturated colors → bolder vibe; flat colors → smart/casual
    const vibe = avgS > 45 ? 'bold' : 'clean';
    return { brightness, vibe, avgL, avgS };
  }

  /* ----------------- product classification ----------------- */
  function classify(product) {
    const type = (product.type || '').toLowerCase();
    const tags = (product.tags || []).map(t => t.toLowerCase());
    const title = (product.title || '').toLowerCase();

    if (type === 'sneakers' || type === 'sandals' || tags.includes('footwear')
        || tags.includes('sneakers') || tags.includes('mules') || tags.includes('shoe')) return 'shoe';

    if (type === 'hoodie' || type === 'sweatshirt' || tags.includes('hoodie')) return 'top';
    if (type === 't-shirt' || type === 'tee' || tags.includes('t-shirt') || tags.includes('tees') || title.includes('tee')) return 'top';
    if (type === 'long sleeve' || type === 'shirt' || tags.includes('long sleeve') || tags.includes('shirt')) return 'top';
    if (tags.includes('tops')) return 'top';

    if (type === 'jeans' || tags.includes('jeans') || title.includes('jean')) return 'bottom';
    if (type === 'shorts' || tags.includes('shorts') || tags.includes('jorts') || title.includes('short') || title.includes('jort')) return 'bottom';
    if (type === 'pants' || type === 'sweat pants' || tags.includes('pants') || tags.includes('cargo')) return 'bottom';
    if (tags.includes('bottoms')) return 'bottom';

    if (type === 'hat' || type === 'cap' || tags.includes('hat') || tags.includes('caps') || title.includes('cap')) return 'accessory';
    if (type === 'socks' || tags.includes('socks')) return 'accessory';
    if (type === 'underwear' || tags.includes('underwear')) return 'accessory';
    if (type === 'accessories' || tags.includes('accessories')) return 'accessory';

    return 'other';
  }

  function colorScore(product, palette) {
    // Score 0..100 based on how many palette colors appear in the product's tags/title
    const tags = (product.tags || []).map(t => t.toLowerCase());
    const title = (product.title || '').toLowerCase();
    let score = 0;
    const lower = palette.map(c => c.toLowerCase());
    for (const c of lower) {
      if (tags.includes(c)) score += 30;
      else if (tags.some(t => t === c || t.split(' ').includes(c))) score += 25;
      else if (title.includes(c)) score += 15;
      else if (tags.some(t => t.indexOf(c) !== -1)) score += 8;
    }
    return Math.min(score, 100);
  }

  function vibeScore(product, vibe) {
    // brightness + vibe gentle bonus
    const tags = (product.tags || []).map(t => t.toLowerCase());
    const title = (product.title || '').toLowerCase();
    let score = 0;

    if (vibe.brightness === 'light') {
      if (tags.includes('white') || tags.includes('cream') || tags.includes('beige')) score += 10;
    } else if (vibe.brightness === 'dark') {
      if (tags.includes('black') || tags.includes('charcoal') || tags.includes('jet black')) score += 10;
    }

    if (vibe.vibe === 'bold') {
      if (tags.some(t => ['red','orange','yellow','green','blue','pink','purple'].includes(t))) score += 6;
      if (title.match(/graphic|print|all.over|tie.dye|distressed|rhinestone|chrome/i)) score += 8;
    } else { /* clean */
      if (tags.includes('essential') || tags.includes('basic') || title.includes('essential')) score += 6;
    }
    return score;
  }

  function rankProducts(palette, vibe) {
    return catalog
      .map(p => ({
        ...p,
        cat: classify(p),
        score: colorScore(p, palette) + vibeScore(p, vibe)
      }))
      .filter(p => p.cat === 'top' || p.cat === 'bottom' || p.cat === 'accessory')
      .filter(p => p.score > 0)
      .sort((a, b) => b.score - a.score);
  }

  /* ----------------- build outfits (up to 8) ----------------- */
  function buildOutfits(palette, vibe, maxOutfits = 8) {
    const ranked = rankProducts(palette, vibe);

    const tops = ranked.filter(p => p.cat === 'top');
    const bottoms = ranked.filter(p => p.cat === 'bottom');
    const accessories = ranked.filter(p => p.cat === 'accessory');

    // Fallbacks if a slot is empty
    const allTops = tops.length ? tops : catalog.filter(p => classify(p) === 'top');
    const allBottoms = bottoms.length ? bottoms : catalog.filter(p => classify(p) === 'bottom');
    const allAccessories = accessories.length ? accessories : catalog.filter(p => classify(p) === 'accessory');

    // De-dup: don't repeat the same top OR bottom across outfits
    const usedTops = new Set();
    const usedBottoms = new Set();
    const usedAccessories = new Set();

    const outfits = [];
    let ti = 0, bi = 0, ai = 0;
    while (outfits.length < maxOutfits && (ti < allTops.length || bi < allBottoms.length)) {
      // Find next unused top
      let top;
      while (ti < allTops.length) {
        if (!usedTops.has(allTops[ti].id)) { top = allTops[ti]; break; }
        ti++;
      }
      if (!top) break;
      usedTops.add(top.id);
      ti++;

      // Find next unused bottom
      let bottom;
      while (bi < allBottoms.length) {
        if (!usedBottoms.has(allBottoms[bi].id)) { bottom = allBottoms[bi]; break; }
        bi++;
      }
      if (!bottom) {
        bi = 0;
        while (bi < allBottoms.length) {
          if (!usedBottoms.has(allBottoms[bi].id)) { bottom = allBottoms[bi]; break; }
          bi++;
        }
      }
      if (!bottom) break;
      usedBottoms.add(bottom.id);
      bi++;

      // Accessory: optional, prefer unused
      let accessory = null;
      while (ai < allAccessories.length) {
        if (!usedAccessories.has(allAccessories[ai].id)) {
          accessory = allAccessories[ai];
          usedAccessories.add(accessory.id);
          ai++;
          break;
        }
        ai++;
      }

      outfits.push({ top, bottom, accessory });
    }
    return outfits;
  }

  /* ----------------- rendering ----------------- */
  function renderSwatches(colors) {
    swatchesEl.innerHTML = '';
    colors.slice(0, 5).forEach(c => {
      const div = document.createElement('div');
      div.className = 'lgnd-mms__swatch';
      div.style.background = `rgb(${c.r},${c.g},${c.b})`;
      div.title = colorFamily(c);
      swatchesEl.appendChild(div);
    });
  }

  function fmt(cents) {
    if (typeof cents === 'string') return cents;
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function outfitCard(outfit, idx) {
    const total = (outfit.top.price_cents || 0) +
                  (outfit.bottom.price_cents || 0) +
                  (outfit.accessory ? outfit.accessory.price_cents || 0 : 0);

    const labels = [
      'FIT 01 · DAILY','FIT 02 · CLEAN','FIT 03 · BOLD','FIT 04 · LAYERED',
      'FIT 05 · STREET','FIT 06 · ELEVATED','FIT 07 · WEEKEND','FIT 08 · STATEMENT'
    ];
    const clean = t => (t || '').replace(/^[^-]+ -\s*/, '');

    const item = (p, role) => p ? `
      <div class="lgnd-mms__item">
        <a href="${p.url}" class="lgnd-mms__item-figure" aria-label="View ${clean(p.title)}">
          <img src="${p.image}" alt="${clean(p.title)}" loading="lazy">
          <span class="lgnd-mms__item-role">${role}</span>
        </a>
        <div class="lgnd-mms__item-meta">
          <a href="${p.url}" class="lgnd-mms__item-title">${clean(p.title)}</a>
          <span class="lgnd-mms__item-vendor">${p.vendor || ''}</span>
          <div class="lgnd-mms__item-foot">
            <span class="lgnd-mms__item-price">${fmt(p.price_cents)}</span>
            <button type="button" class="lgnd-mms__add-one"
              data-variant="${p.variant_id}"
              data-title="${clean(p.title).replace(/"/g,'&quot;')}">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              ADD
            </button>
          </div>
        </div>
      </div>
    ` : '';

    return `
      <article class="lgnd-mms__outfit">
        <header class="lgnd-mms__outfit-head">
          <h3>${labels[idx] || 'FIT ' + (idx + 1)}</h3>
          <span class="lgnd-mms__outfit-total">${fmt(total)}</span>
        </header>
        <div class="lgnd-mms__collage lgnd-mms__collage--${outfit.accessory ? 'three' : 'two'}">
          ${item(outfit.top, 'TOP')}
          ${item(outfit.bottom, 'BOTTOM')}
          ${item(outfit.accessory, 'ACCESSORY')}
        </div>
        <button type="button"
          class="lgnd-mms__btn lgnd-mms__btn--solid lgnd-mms__add-all"
          data-variants="${[outfit.top.variant_id, outfit.bottom.variant_id, outfit.accessory && outfit.accessory.variant_id].filter(Boolean).join(',')}">
          ADD ENTIRE FIT — ${fmt(total)}
        </button>
      </article>
    `;
  }

  function renderOutfits(outfits) {
    if (!outfits.length) { setState('empty'); return; }
    outfitsEl.innerHTML = outfits.map(outfitCard).join('');
    bindAddButtons();
    setState('results');
  }

  function flashToast(msg) {
    let toast = document.querySelector('.lgnd-mms__toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lgnd-mms__toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-visible'), 2400);
  }

  function bindAddButtons() {
    outfitsEl.querySelectorAll('.lgnd-mms__add-all').forEach(btn => {
      btn.addEventListener('click', async () => {
        const ids = btn.dataset.variants.split(',').filter(Boolean).map(Number);
        const original = btn.innerHTML;
        btn.innerHTML = 'ADDING…';
        btn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: ids.map(id => ({ id, quantity: 1 })) })
          });
          window.location = '/cart';
        } catch (e) {
          btn.innerHTML = original;
          btn.disabled = false;
          flashToast('Could not add. Try again.');
        }
      });
    });
    outfitsEl.querySelectorAll('.lgnd-mms__add-one').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = Number(btn.dataset.variant);
        const title = btn.dataset.title || 'Item';
        const original = btn.innerHTML;
        btn.innerHTML = '…';
        btn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] })
          });
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> ADDED';
          btn.classList.add('is-added');
          flashToast(`${title} added to cart`);
          setTimeout(() => {
            btn.innerHTML = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2000);
        } catch (e) {
          btn.innerHTML = original;
          btn.disabled = false;
          flashToast('Could not add. Try again.');
        }
      });
    });
  }

  /* ----------------- main flow ----------------- */
  const SCAN_MESSAGES = [
    'READING COLORS',
    'EXTRACTING PALETTE',
    'DETECTING SHOE VIBE',
    'SCORING THE FLOOR',
    'BUILDING YOUR FITS'
  ];

  function startScanText() {
    const el = document.getElementById('mmsScanStatus');
    if (!el) return null;
    let i = 0;
    const tick = () => {
      i = (i + 1) % SCAN_MESSAGES.length;
      el.textContent = SCAN_MESSAGES[i];
    };
    return setInterval(tick, 700);
  }

  async function processImage(src) {
    const scanImg = document.getElementById('mmsScanImg');
    if (scanImg) scanImg.src = src;
    shoeImg.src = src;
    setState('loading');
    const interval = startScanText();
    const minWait = new Promise(r => setTimeout(r, 2400));
    try {
      const img = await loadImage(src);
      const colors = extractColors(img, 6);
      renderSwatches(colors);

      const families = [...new Set(colors.map(colorFamily))];
      const palette = paletteFor(families);
      const vibe = detectVibe(colors);
      const outfits = buildOutfits(palette, vibe, 8);

      await minWait;
      if (interval) clearInterval(interval);
      renderOutfits(outfits);
    } catch (e) {
      if (interval) clearInterval(interval);
      console.error('process', e);
      setState('empty');
    }
  }

  /* ----------------- bindings ----------------- */
  drop.addEventListener('click', pickFile);
  drop.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') pickFile(); });
  browseBtn.addEventListener('click', e => { e.stopPropagation(); pickFile(); });
  ['dragover', 'dragenter'].forEach(evt =>
    drop.addEventListener(evt, e => { e.preventDefault(); drop.classList.add('is-dragging'); }));
  ['dragleave', 'dragend', 'drop'].forEach(evt =>
    drop.addEventListener(evt, () => drop.classList.remove('is-dragging')));
  drop.addEventListener('drop', e => {
    e.preventDefault();
    const f = e.dataTransfer.files[0];
    if (f) handleFile(f);
  });
  file.addEventListener('change', () => {
    const f = file.files && file.files[0];
    if (f) handleFile(f);
  });
  async function handleFile(f) {
    const url = await fileToDataUrl(f);
    processImage(url);
  }
  samplesGrid.forEach(b => b.addEventListener('click', () => processImage(b.dataset.img)));
  if (restartBtn) restartBtn.addEventListener('click', () => setState('idle'));
  if (restartBtn2) restartBtn2.addEventListener('click', () => setState('idle'));
})();
